import "../../Dashboard/Design/Dashboard.css"
import { useEffect, useRef, useState } from "react";
import { dashboard } from "../../handler/LoginAndSingupHandler";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import courseImage from "src/Common/CourseImage";
import PaymentOrder from "src/Package/PaymentOrder";

const CourseOrders = () => {
    const runOnce = useRef(false);
    type Course = {
        courseId: number,
        courseName: string,
        packageId: number,
        courseDescription: string,
        coursePrice: number
    }
    type PackagePayment = {
        customizedPackagePaymentId: number,
        payment: number,
        paymentDate: string,
        status: number,
        transactionId: number,
    }
    const [packages, setPackages] = useState<Course[]>([
        {
            courseId: 0,
            courseName: "",
            packageId: 0,
            courseDescription: "",
            coursePrice: 0
        }
    ]);
    const [packagePayments, setPackagePayments] = useState<PackagePayment[]>([
        {
            customizedPackagePaymentId: 0,
            payment: 0,
            paymentDate: "",
            status: 0,
            transactionId: 0
        }
    ]);
    const getCourses = async (userInformationId) => {
        var response = await dashboard(3);
        
        if (response.statusCode === 200) {
            setPackages(response.data.dashboard.courses);
            setPackagePayments(response.data.dashboard.customizedPackagePaymentDtos);
        }
    }
    const [showPackageInfo, setShowPackageInfo] = useState(true);

    const handleChange = (event: any) => {
        const {
            target: { value },
        } = event;
        setSelectedCourses(typeof value === "string" ? value.split(",") : value);
    };
    const [selectedCourses, setSelectedCourses] = useState<Course[]>([]);

    const handleAddToCart = (course: Course) => {
        setSelectedCourses((prevSelectedCourses) => [...prevSelectedCourses, course]);
        console.warn(selectedCourses);
    };
    const handleRemoveFromCart = (course: Course) => {
        setSelectedCourses((prevSelectedCourses) =>
            prevSelectedCourses.filter((c) => c.courseId !== course.courseId)
        );
        console.warn(selectedCourses);
    }
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = date.getDate(); // Day of the month
        const month = date.toLocaleString('default', { month: 'long' }); // Full month name
        const year = date.getFullYear(); // Year

        return `${day} ${month} ${year}`;
    };

    const [showModule, setShowModule] = useState("orderCourse");
    const [showInnerModule, setShowInnerModule] = useState("orders");
    useEffect(() => {
        if (runOnce.current === false) {
            runOnce.current = true;
            
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            getCourses(userProfile.userInformationId);
            runOnce.current = true;
        }
    }, [runOnce])
    return <>
        <>
            {
                showModule === "orderCourse" &&
                (
                    <>
                        <section style={{
                            width: "95%",
                            height: "85%",
                            marginTop: "10px",
                            fontFamily: "Arial, sans-serif",
                            display: "flex",
                            flexDirection: "column"
                        }}>
                            <section style={{ background: "white", display: "flex", justifyContent: "space-between" }}>
                                <Button onClick={() => { setShowInnerModule("orderList") }} style={{ width: "50%", background: "skyblue", color: "black" }}>OrderList</Button>
                                <Button onClick={() => { setShowInnerModule("orders") }} style={{ width: "50%", background: "green", color: "black" }}>Order</Button>
                            </section>
                            {
                                showInnerModule === "orderList" &&
                                <>
                                    <section>
                                        <div
                                            className="headerBackground"
                                            style={{
                                                borderRadius: "12px",
                                                padding: "20px",
                                                backgroundColor: "#f7f9fc",
                                                boxShadow: "inset 0 0 0.5px rgba(0, 0, 0, 0.05)"
                                            }}
                                        >
                                            <TableContainer style={{ background: "white" }}>
                                                <h3 style={{ textAlign: "center" }}>Package Payment Requested</h3>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow >
                                                            <TableCell align="center">Sr.No</TableCell>
                                                            <TableCell align="center">Order Id</TableCell>
                                                            <TableCell align="center">DateTime</TableCell>
                                                            <TableCell align="center">TransactionId</TableCell>
                                                            <TableCell align="center">Payment</TableCell>
                                                            <TableCell align="center">Status</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    {packagePayments.map((payment, index) => (
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell align="center">
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell align="center">{payment.customizedPackagePaymentId}</TableCell>
                                                                <TableCell align="center">{formatDate(payment.paymentDate)}</TableCell>
                                                                <TableCell align="center">{payment.transactionId}</TableCell>
                                                                <TableCell align="center">{payment.payment}</TableCell>
                                                                <TableCell align="center">{payment.status === 1 ?
                                                                    <span>Pending</span> : payment.status === 2 ?
                                                                        <span style={{ color: "green" }}>Purchased</span> : <span style={{ color: "red" }}>Rejected</span>}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    ))}
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </section>
                                </>
                            }
                            {
                                showInnerModule === "orders" &&
                                <>
                                    <section style={{
                                        background: "#E0E0E0",
                                        width: "80%",
                                        margin: "20px auto",
                                        fontFamily: "Georgia, serif",
                                        position: "relative",
                                        height: "30%"
                                    }}>
                                        {/* Purchase Order Heading */}
                                        <h2 style={{
                                            textAlign: "center",
                                            color: "#444",
                                            marginBottom: "15px",
                                            fontWeight: "bold"
                                        }}>
                                            Purchase Order
                                        </h2>

                                        {/* Cart Details */}
                                        <div style={{
                                            textAlign: "center",
                                            borderBottom: "1px solid #ccc",
                                            paddingBottom: "20px"
                                        }}>
                                            <h3 style={{
                                                margin: "10px 0",
                                                color: "#444",
                                                fontSize: "18px",
                                                fontWeight: "normal"
                                            }}>
                                                Total Price: ₹{selectedCourses.reduce((sum, course) => sum + course.coursePrice, 0)}
                                            </h3>
                                            {
                                                packagePayments.some(data => data.status === 1) ?
                                                    <>
                                                        <span>Pending Order Exist</span>
                                                    </>
                                                    :
                                                    <Button
                                                        style={{
                                                            backgroundColor: selectedCourses.length === 0 ? "#444" : "green", // Subtle dark gray for a timeless appearance
                                                            color: "white", // White text for contrast
                                                            border: "1px solid #333", // Soft border for structure
                                                            borderRadius: "5px", // Slightly rounded corners
                                                            fontSize: "16px", // Balanced font size
                                                            fontWeight: "bold", // Bold text for emphasis
                                                            fontFamily: "Georgia, serif", // A classic font choice
                                                            cursor: "pointer", // Keep the pointer style for interactivity
                                                            textAlign: "center",
                                                            gap: "20px"
                                                        }}
                                                        onClick={() => {
                                                            setShowModule("payment")
                                                        }}
                                                        disabled={selectedCourses.length === 0}
                                                    >
                                                        CheckOut
                                                        <div style={{
                                                            top: "10px",
                                                            right: "10px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            padding: "10px",
                                                            backgroundColor: "#fff",
                                                            borderRadius: "50%",
                                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                            cursor: "default"
                                                        }}>
                                                            <i
                                                                className="fas fa-shopping-cart" // Replace with a proper icon class from your library
                                                                style={{ fontSize: "20px", color: "#555", marginRight: "5px" }}
                                                            ></i>
                                                            <span style={{ fontSize: "14px", color: "#333" }}>{selectedCourses.length}</span>
                                                        </div>
                                                    </Button>
                                            }
                                        </div>
                                    </section>
                                    <div
                                        className="headerBackground"
                                        style={{
                                            height: "80%",
                                            overflowY: "auto",
                                            borderRadius: "12px",
                                            padding: "20px",
                                            backgroundColor: "#f7f9fc",
                                            boxShadow: "inset 0 0 0.5px rgba(0, 0, 0, 0.05)"
                                        }}
                                    >
                                        {packages.map(course => {
                                            const poster = courseImage.find(data => data.courseId === course.courseId)?.posterLink;
                                            const isSelected = selectedCourses.some(data => data.courseId === course.courseId);

                                            return (
                                                <div
                                                    key={course.courseId}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        gap: "20px",
                                                        marginBottom: "20px",
                                                        padding: "20px",
                                                        background: "linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%)",
                                                        borderRadius: "12px",
                                                        boxShadow: "0 4px 14px rgba(0, 0, 0, 0.06)",
                                                        transition: "transform 0.2s ease-in-out"
                                                    }}
                                                    onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.02)")}
                                                    onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
                                                >
                                                    <div style={{ width: "35%", overflow: "hidden", borderRadius: "10px" }}>
                                                        <img
                                                            src={poster}
                                                            alt={course.courseName}
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                borderRadius: "10px",
                                                                objectFit: "cover",
                                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                                                            }}
                                                        />
                                                    </div>

                                                    <div style={{ width: "65%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                        <h3 style={{ margin: 0, fontSize: "20px", color: "#2c3e50", fontWeight: "600" }}>
                                                            {course.courseName}
                                                        </h3>

                                                        <p style={{ fontSize: "16px", fontWeight: "500", color: "#34495e" }}>
                                                            Price: ₹{course.coursePrice}
                                                        </p>

                                                        <button
                                                            style={{
                                                                padding: "12px 20px",
                                                                backgroundColor: isSelected ? "#e74c3c" : "#27ae60",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "6px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                cursor: "pointer",
                                                                alignSelf: "flex-start",
                                                                transition: "background-color 0.3s ease"
                                                            }}
                                                            onClick={() =>
                                                                isSelected ? handleRemoveFromCart(course) : handleAddToCart(course)
                                                            }
                                                            onMouseOver={e =>
                                                                (e.currentTarget.style.backgroundColor = isSelected ? "#c0392b" : "#219150")
                                                            }
                                                            onMouseOut={e =>
                                                                (e.currentTarget.style.backgroundColor = isSelected ? "#e74c3c" : "#27ae60")
                                                            }
                                                        >
                                                            {isSelected ? "Remove from Cart" : "Add to Cart"}
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            }
                        </section>
                    </>
                )
            }
        </>
        <>
            {
                showModule === "payment" &&
                (
                    <>
                        <div style={{ overflow: 'auto', maxHeight: '700px', border: '1px solid #ccc', padding: '10px' }}>
                            <Button onClick={() => { (setShowModule("orderCourse")); }} style={{ borderRadius: "20px", color: "white", background: "#343434", position: "fixed", top: "10px", left: "10px" }}><i className="fa-solid fa-arrow-left"></i></Button>
                            <PaymentOrder courses={selectedCourses} payment={selectedCourses.reduce((sum, course) => sum + course.coursePrice, 0)} />
                        </div>
                    </>
                )
            }
        </>
    </>
};

export default CourseOrders;